import React from 'react';
import PropTypes from 'prop-types';
import {
  FDIcon,
  FDLabelText,
  FDLozenge,
  FDPaper,
  FDSecondaryActionIconButton,
  FDStack,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import { useRightColumnContext } from 'Context/RightColumnContext';
import { dataAttrs } from 'Helpers/Testing';

const ThreadRoutingDetailsContent = ({ resource }) => {
  const { displayErrorMessage } = useSnackbarContext();
  const { loadRightColumnCollectionLink, rightColumnCollectionLoading } = useRightColumnContext();
  const [routedThreadLoading, setRoutedThreadLoading] = React.useState(false);
  const { selectThread } = useMessagesContext();

  if (!resource) {
    return null;
  }

  const handleRoutedThreadClick = async (rel) => {
    try {
      setRoutedThreadLoading(true);
      const [threadResource] = await rel.link('related').get();
      selectThread(threadResource);
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to go to routed thread');
    } finally {
      setRoutedThreadLoading(false);
    }
  };

  const handleThreadHistoryClick = async (rel) => {
    try {
      loadRightColumnCollectionLink(rel.link('related'));
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to open thread history');
    }
  };

  return (
    <FDPaper appearance={'flat'} color={'info'} {...dataAttrs('thread-routing-details')}>
      <FDStack paddingX={2} paddingY={1} justifyContent={'space-between'} direction={'row'}>
        <FDStack direction={'row'} spacing={1} alignItems={'center'}>
          <FDIcon icon={resource.attr('icon')} size={'sm'} />
          <FDLabelText value={resource.attr('title')} />
        </FDStack>
        <FDStack direction={'row'} spacing={1} alignItems={'center'}>
          <FDLozenge color={resource.attr('status')} label={resource.attr('statusLabel')} />
          {
            resource.withRelationship(
              fr.relationships.threadHistory.name,
              (rel) => {
                return (
                  <FDSecondaryActionIconButton
                    disablePadding
                    onClick={() => handleThreadHistoryClick(rel)}
                    loading={rightColumnCollectionLoading ?? false}
                    icon={'history'}
                    {...dataAttrs('thread-history-button')}
                  />
                );
              },
              () => null,
            )
          }
          {
            resource.withRelationship(
              fr.relationships.routedThread.name,
              (rel) => {
                return (
                  <FDSecondaryActionIconButton
                    disablePadding
                    onClick={() => handleRoutedThreadClick(rel)}
                    loading={routedThreadLoading}
                    icon={'chevronRight'}
                    {...dataAttrs('routed-thread-button')}
                  />
                );
              },
              () => null,
            )
          }
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

ThreadRoutingDetailsContent.defaultProps = {
};

ThreadRoutingDetailsContent.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ThreadRoutingDetailsContent;
